export enum FilledButtonSizeEnum {
  SMALL,
  MEDIUM,
  LARGE,
  EXTRA_LARGE,
}
